import { ArrowLeftOutlined } from '@ant-design/icons';
import { Col, Divider, Row, Typography } from 'antd';
const { Title, Text } = Typography;
import { DossierListTable } from 'client/components/schema/procedures/table/DossierListTable';
import { PageMainColumn } from 'client/ui/layout/page/PageMainColumn';
import { DocumentDossier } from 'common/dto/RequestDossierDto';
import { IRequest } from 'common/schema/request/Request';
import { RequestResponseFileType } from 'common/schema/request/RequestResponseFileType';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { DocumentTree } from './useRequestDocumentTree';
import { getRequestDossierContentColumns } from './content-tree/getRequestDossierContentColumns';
import { tableLoaderSpin } from 'client/ui/loader/tableLoaderSpin';
import { RequestProcedureInfo } from '../../procedures/single/shared/RequestProcedureInfo';

interface IProps {
  id: number | null;
  request: IRequest;
  backLink: string;
  backText: string;
  documentTree: DocumentTree;
  isAdmin?: boolean;
}

export function RequestDossierMainColumn(props: IProps) {
  const { id, request, backLink, backText, documentTree } = props;
  const [expandedRows, setExpandedRows] = useState<string[]>([]);

  const columns = getRequestDossierContentColumns(
    expandedRows,
    id,
    props.isAdmin
  );

  const onExpandFolder = async (
    expanded: boolean,
    dossier: DocumentDossier
  ) => {
    // TODO Gestione errori document tree loadDocument
    if (expanded) await documentTree.loadDocument(dossier);

    const listUpdated = expanded
      ? [dossier.token, ...expandedRows]
      : expandedRows.filter(token => token != dossier.token);
    return setExpandedRows(listUpdated);
  };

  return (
    <PageMainColumn isAdmin={props.isAdmin}>
      <Row align="middle">
        <Col flex="1 1 auto">
          <Link to={backLink}>
            <span style={{ fontSize: '1.14em', marginBottom: '12px' }}>
              <ArrowLeftOutlined /> {backText}
            </span>
          </Link>
        </Col>
        <Col flex="0 0 auto" style={{ textAlign: 'right' }}>
          <Text type="secondary">{request.code}</Text>
        </Col>
      </Row>

      <Row>
        <Col>
          <RequestProcedureInfo request={request} />
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col flex="auto">
          <Title level={4} style={{ marginTop: '12px', marginBottom: 0 }}>
            Fascicolo della Domanda
          </Title>
        </Col>
      </Row>

      <DossierListTable
        title="Elenco dei Documenti"
        loading={tableLoaderSpin(
          documentTree.loading || !documentTree.documents
        )}
        tableLayout="fixed"
        rowKey={record => record.token}
        dataSource={documentTree.documents}
        columns={columns}
        pagination={false}
        indentSize={30}
        expandable={{
          expandRowByClick: true,
          rowExpandable: record =>
            record.type === RequestResponseFileType.Dossier,
          onExpand: async (expanded, record) => {
            if (record.type === RequestResponseFileType.Dossier)
              await onExpandFolder(expanded, record);
          }
        }}
      />
    </PageMainColumn>
  );
}
